import { render, staticRenderFns } from "./defaultOrder.vue?vue&type=template&id=bfe4a44e"
import script from "./defaultOrder.vue?vue&type=script&lang=js"
export * from "./defaultOrder.vue?vue&type=script&lang=js"
import style0 from "./defaultOrder.vue?vue&type=style&index=0&id=bfe4a44e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports